import { render } from "./GraficoEntregasPorCoordenador.vue?vue&type=template&id=b2463eb0&scoped=true"
import script from "./GraficoEntregasPorCoordenador.vue?vue&type=script&lang=js"
export * from "./GraficoEntregasPorCoordenador.vue?vue&type=script&lang=js"

import "./GraficoEntregasPorCoordenador.vue?vue&type=style&index=0&id=b2463eb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2463eb0"]])

export default __exports__